// extracted by mini-css-extract-plugin
module.exports = {"image":"Home_image__3DuFa"};